<!-- <ng-container>
    <div class="header">
        <h2>Are you sure ?</h2>
    </div>
    <div class="row">

        <div class="col-md-12 mb-3">
            <div *ngIf="data?.other_users_rx?.length">
                Rx 
                <span class="fw-bold" *ngFor="let d of data?.other_users_rx; let i = index">
                  {{ d }}<span *ngIf="i < data.other_users_rx.length - 1">, </span>
                </span> 
                is not associated with this user
              </div>
        </div>

        <div class="col-md-12 d-flex">
            <button class="custom-btn mr-3" *ngIf="data?.same_user_rx.length != 0" (click)="submitForm()">
                Update
            </button>
            <button class="custom-btn" mat-dialog-close>Cancel</button>
        </div>
    </div>
</ng-container> -->

<!-- <form> -->
    <div class="d-flex justify-content-between align-items-center my-2">
      <div class="d-flex align-items-center">
        <img
          src="assets/images/random_assets/process_payment_icon.png"
          alt="process_payment_icon"
        />
        <div class="card-sub-heading ml-3 bold">Order Process</div>
      </div>
        <button mat-icon-button (click)="dialogRef.close()" type="button">
          <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
        </button>
    </div>

    <!-- <ng-template > -->
      <div class="ml-3 my-3">
        <!-- <div class="card-sub-heading" *ngIf="data?.other_users_rx?.length > 0 && data?.same_user_rx?.length <= 0">All Rx are diff.</div>
        <div class="card-sub-heading" *ngIf="data.other_users_rx.length > 0 && data.same_user_rx.length > 0">Some same and some different Rx</div> -->
        <div class="card-sub-heading">Result !</div>
      </div>
  
      <ng-container *ngIf="data?.other_users_rx?.length > 0 && data?.same_user_rx?.length <= 0">
        <div class="d-flex justify-content-between px-3 py-3">
          <div>The entered Rx ID(s) are not associated with your account. We are unable to proceed further.</div>
        </div>
      </ng-container>
      <!-- <hr /> -->
      <ng-container *ngIf="data?.other_users_rx?.length > 0 && data?.same_user_rx?.length > 0">
        <div class="d-flex justify-content-between px-3 py-3">
          <div>Order will not be processed for following Rx(s):</div>
        </div>
        <div
          class="d-flex justify-content-between px-3"
        >
          <div class="pb-3">
            <strong>Rx ID(s): </strong>
            <span *ngFor="let d of data?.other_users_rx; let i = index">
                {{ d }}<span *ngIf="i < data.other_users_rx.length - 1">, </span>
            </span> 
          </div>
        </div>
        <hr />
      </ng-container>
      <ng-container *ngIf="((data?.other_users_rx?.length <= 0 && data?.same_user_rx?.length > 0) || (data?.other_users_rx?.length > 0 && data?.same_user_rx?.length > 0)) && data?.check_wylo_rx_for_din?.match == true">
        <div class="d-flex justify-content-between px-3 py-3">
          <div>Order will be processed for following Rx(s):</div>
        </div>
        <div
          class="d-flex justify-content-between px-3"
        >
          <div class="pb-3">
            <strong>Rx ID(s): </strong>
            <span *ngFor="let d of data?.same_user_rx; let i = index">
                {{ d }}<span *ngIf="i < data.same_user_rx.length - 1">, </span>
            </span> 
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="((data?.other_users_rx?.length <= 0 && data?.same_user_rx?.length > 0) || (data?.other_users_rx?.length > 0 && data?.same_user_rx?.length > 0)) && data?.check_wylo_rx_for_din?.match == false">
       <div class="d-flex justify-content-between px-3 py-3">
         <!-- <div>Do you want to process the order any for the treatment using unmatched following DIN number(s)?</div> -->
         <div>Not all associated medications for this visit have been added. Are you sure you want to proceed without the following medication(s)?</div>
       </div>
       <div class="d-flex justify-content-between px-3">
         <div class="pb-3">
           <strong>Medication(s): </strong>{{ data?.check_wylo_rx_for_din?.diff_treatment }}           
         </div>
       </div>
      </ng-container>
  
      <div class="d-flex mt-3">
        <div class="col-md-12 d-flex justify-content-center" *ngIf="data?.same_user_rx.length != 0" (click)="submitForm()">
          <button class="custom-btn w-100" type="button">Continue</button>
        </div>
      </div>
    <!-- </ng-template> -->
  <!-- </form> -->
  
